import { render, staticRenderFns } from "./InventoryRemove.vue?vue&type=template&id=130f1d62&scoped=true"
import script from "./InventoryRemove.vue?vue&type=script&lang=ts"
export * from "./InventoryRemove.vue?vue&type=script&lang=ts"
import style0 from "./InventoryRemove.vue?vue&type=style&index=0&id=130f1d62&lang=scss"
import style1 from "./InventoryRemove.vue?vue&type=style&index=1&id=130f1d62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f1d62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130f1d62')) {
      api.createRecord('130f1d62', component.options)
    } else {
      api.reload('130f1d62', component.options)
    }
    module.hot.accept("./InventoryRemove.vue?vue&type=template&id=130f1d62&scoped=true", function () {
      api.rerender('130f1d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory-inwards/components/InventoryRemove.vue"
export default component.exports